<template>
  <div>
    <div v-if="object.warehouse_operation_id">{{ $t('sale_of_goods') }}</div>
    <div v-if="!object.record && !object.warehouse_operation_id && object.parent?.warehouse_operation_id">
      {{ $t('sale_of_goods_refund') }}
    </div>
    <div v-if="object.record">
      <router-link class=""
                   v-if="!isPatient"
                   :to="{ name: 'PatientVisitPage', params: { visitid: object.record.id, id: object.record.client_id, page: 'teeth' } }">
        <div>#{{ object.record.id}} {{ $t('from') }} {{ formatDate(object.record.start, 'DD.MM.YYYY, HH:mm') }}</div>
      </router-link>
      <div v-else>
        #{{ object.record.id}} {{ $t('from') }} {{ formatDate(object.record.start, 'DD.MM.YYYY, HH:mm') }}
      </div>
      <div v-if="object.record.status === 2" class="small text-danger mt-1">* {{ $t('cancelled') }}</div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/extensions/filters/filters"

export default {
  name: "PatientsDatatableTDPaymentVisit",
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    isPatient() {
      return this.$store.getters.isPatient
    }
  },
  methods: {
    formatDate
  }
}
</script>
